export enum AddressType {
  TRAINER_HOME = "TRAINER_HOME",
  CLIENT_HOME = "CLIENT_HOME",
  TRAINING_FACILITY = "TRAINING_FACILITY",
  OUTDOOR = "OUTDOOR",
  FLEX = "FLEX",
  UNKNOWN = "UNKNOWN",
}

export enum LanguageType {
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
  AMERICAN_SIGN_LANGUAGE = "AMERICAN_SIGN_LANGUAGE",
  INDONESIAN = "INDONESIAN",
  FRENCH = "FRENCH",
  CHINESE = "CHINESE",
  PORTUGUESE = "PORTUGUESE",
  HMONG = "HMONG",
  HINDI = "HINDI",
  RUSSIAN = "RUSSIAN",
  GERMAN = "GERMAN",
  JAPANESE = "JAPANESE",
  HEBREW = "HEBREW",
  TURKISH = "TURKISH",
  ROMANIAN = "ROMANIAN",
  ITALIAN = "ITALIAN",
  DUTCH = "DUTCH",
  SWEDISH = "SWEDISH",
  FINNISH = "FINNISH",
  DANISH = "DANISH",
  GREEK = "GREEK",
  POLISH = "POLISH",
  AFRIKAANS = "AFRIKAANS",
}
